
/**
 * BaseEntity Lifecycle statuses
 */

const Lifecycle = {
	Predeployed: "Predeployed",
	Staged: "Staged",
	Available: "Available",
	Published: "Published",
	Suspended: "Suspended",
	Expired: "Expired",
	Deleted: "Deleted",
	UnderConstruction: "UnderConstruction"
};

export default Lifecycle;



// WEBPACK FOOTER //
// ./src/common/entities/Lifecycle.ts